import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Injector,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core'
import { GbProfileSelectStore } from './gb-profile-select.store'
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms'
import { ProfileFilters, ProfilesEntity } from 'libs/gb-dashboard/user/data-access/src/lib/+state/profiles.models'

@Component({
  selector: 'gb-profile-select',
  templateUrl: './gb-profile-select.component.html',
  styleUrls: ['./gb-profile-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GbProfileSelectStore,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GbProfileSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class GbProfileSelectComponent implements ControlValueAccessor, OnInit {
  @Input() filters?: ProfileFilters
  @Output() selectedOptionChanged = new EventEmitter<ProfilesEntity | undefined>()
  @Output() selectedOptionClear = new EventEmitter<void>()

  loading$ = this.gbProfileSelectStore.loading$
  profiles$ = this.gbProfileSelectStore.profiles$

  private onChange: (value: any) => void = () => {}
  private onTouched: () => void = () => {}

  get ngControl(): NgControl | null {
    return this.injector.get(NgControl, null)
  }

  get control(): FormControl | undefined {
    return this.ngControl?.control as FormControl | undefined
  }

  constructor(
    private gbProfileSelectStore: GbProfileSelectStore,
    private injector: Injector,
  ) {}

  ngOnInit(): void {
    this.gbProfileSelectStore.loadFirstPageProfiles(this.filters)
  }

  writeValue(value: ProfilesEntity | null): void {
    if (value) {
      this.control?.setValue(value)
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  onSelect(selectedProfile: ProfilesEntity | null) {
    this.onChange(selectedProfile)
    this.onTouched()
  }

  onSearch(search: string): void {
    this.gbProfileSelectStore.searchProfiles(search)
  }

  onScrollToEnd(): void {
    this.gbProfileSelectStore.loadNextPageProfiles()
  }

  onClear(): void {
    this.gbProfileSelectStore.loadFirstPageProfiles(this.filters)
    this.onSelect(null)
    this.selectedOptionClear.emit()
  }
}
